import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import { Box } from '../Box'
import { Button } from '../Button'
import { Flex } from '../Flex'
import { Image } from '../Image'
import { ThemeWrapper, brkmax, themeColor } from '../theme'

const Wrapper = styled(Flex)<{ backgroundColor?: string; textColor: string }>`
  background-color: ${p => p.backgroundColor || themeColor('bgPrimary')(p)};

  display: none;

  .rich-text-content {
    p {
      color: ${p => (p.textColor === 'Light' ? themeColor('white')(p) : themeColor('darkGray')(p))};
    }

    p:last-of-type {
      margin-bottom: 0;
    }
  }

  &.shown {
    display: flex;
  }
`

const ContentContainer = styled.div`
  margin: 8px 12px 8px 24px;
  flex: 1 1 auto;
  display: flex;

  ${brkmax(
    1,
    css`
      flex-wrap: wrap;
      margin: 20px 12px 20px 16px;

      img {
        margin-top: 10px;
      }
    `
  )}
`

const CloseIconWrapper = styled.div`
  margin-right: 43px;
  margin-left: 12px;
  margin-top: 6px;

  ${brkmax(
    1,
    css`
      margin-right: 16px;
      margin-left: 12px;
      margin-top: 12px;
    `
  )}
`

const BannerImage = styled(Image)`
  max-height: 24px;
  max-width: 100%;
`

const DescriptionBox = styled(Box)`
  padding-right: 24px;
  flex: 1 1 auto;

  ${brkmax(
    1,
    css`
      padding-right: 0;
      width: 100%;
    `
  )}
`

export type PageBannerProps = {
  closedBannerId: string
  setClosedBannerId: (id: string) => void
  bannerData:
    | {
        id: string
        description: string
        textColor: string
        image?: {
          url: string
          alt?: string
        }
        backgroundColor?: string
      }
    | undefined
}

export const PageBanner = ({ closedBannerId, setClosedBannerId, bannerData: banner }: PageBannerProps) => {
  const [visible, setVisible] = useState(closedBannerId !== banner?.id)

  useEffect(() => {
    setVisible(closedBannerId !== banner?.id)
  }, [banner?.id, closedBannerId])

  if (!banner) return null

  const hasImage = !!banner.image

  return (
    <ThemeWrapper>
      <Wrapper
        className={visible ? 'shown' : undefined}
        backgroundColor={banner.backgroundColor}
        textColor={banner.textColor}
      >
        <ContentContainer>
          <DescriptionBox>
            <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: banner.description }}></div>
          </DescriptionBox>
          {hasImage && (
            <Box display="flex" justifyContent="center" alignItems="center">
              <BannerImage src={banner.image?.url} alt={banner.image?.alt}></BannerImage>
            </Box>
          )}
        </ContentContainer>
        <CloseIconWrapper>
          <Button
            variant="transparent"
            padding="0px"
            size="small"
            onClick={() => {
              setClosedBannerId(banner.id)
              setVisible(false)
            }}
          >
            <Image type="closeBlack" alt="close" />
          </Button>
        </CloseIconWrapper>
      </Wrapper>
    </ThemeWrapper>
  )
}
